var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal--license fixed w-full h-full top-0 left-0" },
    [
      _c(
        "div",
        { staticClass: "modal--inner relative container bg-white shadow-md" },
        [
          _c(
            "div",
            {
              staticClass:
                "button--close absolute top-0 right-0 mt-1 mr-1 cursor-pointer",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M33.2138 11.2175L30.7634 8.75L21.0483 18.5325L11.3333 8.75L8.88281 11.2175L18.5978 21L8.88281 30.7825L11.3333 33.25L21.0483 23.4675L30.7634 33.25L33.2138 30.7825L23.4988 21L33.2138 11.2175Z",
                      fill: "#00263E",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-wrap border-b-1 border-blue-default pb-1",
            },
            [
              _c("div", { staticClass: "w-6/12 flex items-center" }, [
                _c("h4", { staticClass: "font-bold text-blue-dark pl-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.content.compare.header[0]
                          ? _vm.content.compare.header[0]
                          : ""
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-3/12 text-center text--wrapper" }, [
                _c("p", {
                  staticClass: "text-22 text-blue-dark font-semibold",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.content.compare.header[1]
                        ? _vm.content.compare.header[1]
                        : ""
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-3/12 text-center text--wrapper" }, [
                _c("p", {
                  staticClass: "text-22 text-blue-dark font-semibold",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.content.compare.header[2]
                        ? _vm.content.compare.header[2]
                        : ""
                    ),
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.content.compare.features, function (feature, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "flex flex-wrap border-b-1 border-gray-neutral-250 last:border-b-0 last:bg-white",
                class:
                  index % 2 !== 0 ? "bg-gray-neutral-100 bg-opacity-50" : "",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-6/12 flex items-center border-r-1 border-gray-neutral-250",
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "text-blue-dark text-xl my-1 pl-1" },
                      [
                        _vm._v(
                          "\n          " + _vm._s(feature.title) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-3/12 flex items-center justify-center text-center border-r-1 border-gray-neutral-250",
                  },
                  [
                    feature.col1 === true
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("ellipse", {
                              attrs: {
                                cx: "6.02014",
                                cy: "6",
                                rx: "5.95862",
                                ry: "6",
                                fill: "#00263E",
                              },
                            }),
                          ]
                        )
                      : feature.col1 === false
                      ? _c("span")
                      : (feature.col1 !== true || feature.col1 !== false) &&
                        feature.col1
                      ? _c(
                          "p",
                          { staticClass: "text-blue-dark text-xl px-1" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(feature.col1) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-3/12 flex items-center justify-center text-center",
                  },
                  [
                    feature.col2 === true
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("ellipse", {
                              attrs: {
                                cx: "6.02014",
                                cy: "6",
                                rx: "5.95862",
                                ry: "6",
                                fill: "#00263E",
                              },
                            }),
                          ]
                        )
                      : feature.col2 === false
                      ? _c("span")
                      : (feature.col2 !== true || feature.col2 !== false) &&
                        feature.col2
                      ? _c(
                          "p",
                          { staticClass: "text-blue-dark text-xl px-1" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(feature.col2) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }